
export const MAP_PROJECT_DEFINIION = {
    projection: 'EPSG:5514',
    resolutions: [2048.256, 1024.128, 512.064, 256.032, 128.016, 64.008, 32.004, 16.002, 8.001, 4.0005, 2.00025, 1.000125, 0.5000625, 0.25003125, 0.125015625, 0.0625078125],
    center: [-591600, -1197700],
    zoom: 3,
    //minZoom: 3,
    //maxZoom: 15,

    layers: [
        {
            id: 'zm10',
            type: 'TileWMS',
            minZoom: 10,
            source: {
                url: 'https://geoportal.cuzk.cz/WMS_ZM10_PUB/WMService.aspx',
                params: {'LAYERS': 'GR_ZM10', 'TILED': true}
            }
        }, {
            id: 'zm25',
            type: 'TileWMS',
            minZoom: 8,
            maxZoom: 10,
            source: {
                url: 'https://geoportal.cuzk.cz/WMS_ZM25_PUB/WMService.aspx',
                params: {'LAYERS': 'GR_ZM25', 'TILED': true}
            }
        }, {
            id: 'zm50',
            type: 'TileWMS',
            minZoom: 7,
            maxZoom: 8,
            source: {
                url: 'https://geoportal.cuzk.cz/WMS_ZM50_PUB/WMService.aspx',
                params: {'LAYERS': 'GR_ZM50', 'TILED': true}
            }
        }, {
            id: 'zm100',
            type: 'TileWMS',
            minZoom: 6,
            maxZoom: 7,
            source: {
                url: 'https://geoportal.cuzk.cz/WMS_ZM100_PUB/WMService.aspx',
                params: {'LAYERS': 'GR_ZM100', 'TILED': true}
            }
        }, {
            id: 'zm200',
            type: 'TileWMS',
            maxZoom: 6,
            source: {
                url: 'https://geoportal.cuzk.cz/WMS_ZM200_PUB/WMService.aspx',
                params: {'LAYERS': 'GR_ZM200', 'TILED': true}
            }
        }, {
            id: 'orto',
            type: 'TileWMS',
            source: {
                url: 'https://geoportal.cuzk.cz/WMS_ORTOFOTO_PUB/WMService.aspx',
                params: {'LAYERS': 'GR_ORTFOTORGB', 'TILED': true}
            }
        }, {
            id: 'geo',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'geo'}
            }
        }, {
            id: 'pedo',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'pedo'}
            }
        }, {
            id: 'hist_ku',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'hist_ku'}
            }
        }, {
            id: 'vinarske_podoblasti',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'vinarske_podoblasti'}
            }
        }, {
            id: 'trate',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'trate'}
            }
        }, {
            id: 'historicke_trate',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'historicke_trate'}
            }
        }, {
            id: 'lisy',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'lisy'}
            }
        }, {
            id: 'stavby',
            type: 'ImageWMS',
            source: {
                url: '/api/mapserver?map=/data/default.map',
                params: {'LAYERS': 'stavby'}
            }
        }
    ],

    virtualLayers: [
        {
            id: 'base_zm',
            layers: ['zm10', 'zm25', 'zm50', 'zm100', 'zm200'],
            title: 'Základní mapa',
            base: true
        }, {
            id: 'base_orto',
            layers: ['orto'],
            title: 'Letecká mapa',
            base: true
        }, {
            id: 'over_geo',
            layers: ['geo'],
            title: 'Geologická mapa'
        }, {
            id: 'over_pedo',
            layers: ['pedo'],
            title: 'Pedologická mapa'
        }, {
            id: 'over_trate',
            layers: ['trate'],
            title: 'Současné viniční tratě',
            markdown: 'Odrudova_skladba'
        }, {
            id: 'over_historicke_trate',
            layers: ['historicke_trate'],
            title: 'Historické viniční tratě (1840)',
            markdown: 'Terroir'
        }, {
            id: 'over_hist_ku',
            layers: ['hist_ku'],
            title: 'Vinorodá jižní Morava (1840)',
            markdown: 'Terroir'
        }, {
            id: 'over_vinarske_podoblasti',
            layers: ['vinarske_podoblasti'],
            title: 'Vinařské podoblasti'
        }, {
            id: 'over_lisy',
            layers: ['lisy'],
            title: 'Vinohradnické lisy'
        }, {
            id: 'over_stavby',
            layers: ['stavby'],
            title: 'Převažující vinohradnické stavby',
            markdown: 'Typologie_objektu'
        }
    ],

    virtualLayerGroups: [
        {
            id: 'base',
            title: 'Podkladové vrstvy',
            layers: [
                'base_zm',
                'base_orto'
            ]
        }, {
            id: 'over',
            title: 'Volitelné vrstvy',
            layers: [
                'over_geo',
                'over_pedo',
                'over_trate',
                'over_hist_ku',
                'over_historicke_trate',
                'over_vinarske_podoblasti',
                'over_lisy',
                'over_stavby'
            ]
        }
    ],

    defaultVisibleLayers: ['base_zm', 'over_trate']
};
